import select from '@signal/utils/select'
import {
  createThemeSelector,
  createVariableThemeSelectorCreator
} from './utils'

export const zIndexSelector = createThemeSelector(theme => theme.zIndex)

export const getElevationLayerSelector = createVariableThemeSelectorCreator(
  layerName => createThemeSelector(zIndexSelector, select(layerName))
)

export const tableHeaderZIndexSelector = 500
export const mobileStepperZIndexSelector = getElevationLayerSelector(
  'mobileStepper'
) // 1000
export const pageToolbarZIndexSelector = mobileStepperZIndexSelector
export const appBarZIndexSelector = getElevationLayerSelector('appBar') // 1100
export const drawerZIndexSelector = getElevationLayerSelector('drawer') // 1200
export const modalZIndexSelector = getElevationLayerSelector('modal') // 1300
export const snackbarZIndexSelector = getElevationLayerSelector('snackbar') // 1400
export const tooltipZIndexSelector = getElevationLayerSelector('tooltip') // 1500

export const getAdjustedZIndexSelector = (zIndexSelector, number) => props => {
  const zIndex = zIndexSelector(props) + number
  return zIndex
}
